<template>
  <div>
    <vxe-grid
      ref="techTable"
      auto-resize
      resizable
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="500"
      size="mini"
      border
      row-id="pdProcessDictTechCode"
      :checkbox-config="{ highlight: true, reserve: true, trigger: 'row' }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          title: this.$l('table_label_pdProcessDictStep') || '工序',
          field: 'v_pdProcessDictStep',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_techName') || '工艺',
          field: 'techName',
          minWidth: 150,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_techDesc') || '工艺说明',
          field: 'techDesc',
          minWidth: 200,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_techChargeUnit') || '计价单位',
          field: 'techChargeUnitText',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: '单价',
          field: 'unitPrice',
          align: 'center',
          width: 100,
          formatter: ({ row }) => {
            const { unitPrice: value } = row
            return format(value)
          },
          showHeaderOverflow: true,
        },
      ],
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    getCheckboxRecords() {
      const records = this.$refs.techTable.getCheckboxRecords()
      const reserves = this.$refs.techTable.getCheckboxReserveRecords()
      return records.concat(reserves)
    },
    setCheckboxRow(rows, checked) {
      if (!rows) return
      this.$refs.techTable.setCheckboxRow(rows, checked)
      this.$emit('checkbox-change', this.getCheckboxRecords())
    },
  },
}
</script>
